<template>
    <div class="container-fluid">
        <Breadcrumb title="SpamTrap MX List" button-url="spamMxCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="form-inline">
                            <div class="form-group mb-2">
                                <button type="button" class="btn btn-success btn-rounded"
                                        @click="addSpamMxList"><i
                                        class="fas fa-upload"></i>
                                    Upload file with MX list
                                </button>
                            </div>
                            <div class="form-group mx-sm-3 mb-2" v-if="totalItems > 0">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group p-t-10">
                            <div class="progress" v-for="(uploadMX,index) in uploadMxs" :key="index">
                                <div class="progress-bar bg-info"
                                     v-bind:style="{width: uploadMxs.completion}" role="progressbar"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                    {{uploadMxs.completion}}
                                </div>
                            </div>
                        </div>
                        <div class="input-group form-group">
                            <input v-model="spamMxSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search MX">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div v-if="spamMxList.length === 0">SpamTrap MX list is empty!</div>
                        <div v-else>
                            <div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>MX</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(record, index) in spamMxList" :key="index">
                                            <td class="align-middle">{{record.id}}</td>
                                            <td class="align-middle">{{record.value}}</td>
                                            <td>
                                                <button type="button" class="btn btn-danger btn-sm m-r-15"
                                                        @click="deleteSpamMx(record.id)">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamMxService from '../services/SpamMxService';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import { mapGetters } from 'vuex';

    export default {
        name: 'SpamMxs',
        components: {
            Breadcrumb,
            Preloader
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                spamMxSearch: null,
                spamMxList: [],
                spamMxsFile: '',
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                jobs: [],
                uploadMxs: []
            }
        },
        mounted() {
            this.getItems(this.page = 1);
            this.uploadSpamMxListProgress();
        },
        methods: {
            search: function () {
                this.getItems(this.page = 1);
            },
            uploadSpamMxListProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadSpamMxProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadSpamMxProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadSpamMxProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadSpamMxProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data) {
                        let index = this.uploadMxs.findIndex(obj => obj.uuid === data.uuid);
                        if (index < 0) {
                            this.uploadMxs.push({
                                'uuid': data.uuid,
                                'completion': parseInt(data.completion) + '%'
                            });
                        } else {
                            this.uploadMxs[index].completion = parseInt(data.completion) + '%';
                            if (100 === parseInt(data.completion)) {
                                this.$snotify.success('File ' + data.filename + ' is processed!');
                                this.uploadMxs.splice(index, 1);
                                this.getItems(this.page);
                            }
                        }
                    }
                }
            },
            addSpamMxList() {
                Swal({
                    title: 'Add Spam MX List',
                    html: '<input type="file" id="spam_mxs" accept="text/csv" />',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let mxs = document.getElementById('spam_mxs').files[0];
                        let formData = new FormData();
                        formData.append('spam_mxs', mxs);
                        return SpamMxService.addSpamMxs(formData).then(response => {
                            if (response.status === 200) {
                                this.$snotify.warning('File processing started!');
                            }
                            if (response.data.error) {
                                Swal.showValidationMessage(
                                    `${response.data.error.spam_mxs}`
                                );
                                return false;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `We will notify you, when moderation process will be done.`,
                            'success'
                        )
                    }
                })
            },
            deleteSpamMx(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SpamMxService.deleteSpamMx(id).then((response) => {
                            if (response.status === 200) {
                                let index = this.spamMxList.findIndex(obj => obj.id === id);
                                this.spamMxList.splice(index, 1);
                                this.totalItems--;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Spam trap MX has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            getItems: function (pageNum) {
                this.loading = true;
                SpamMxService.getSpamMxList(pageNum, this.perPage, this.spamMxSearch).then(response => {
                    this.spamMxList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    }
</script>

<style scoped>

</style>
